import { Link } from "react-router";
import ScriptText from "@/components/ui/ScriptText";
import { footerContent } from "@/data/content";
import { useContent } from "@/hooks/useContent";

export default function Footer() {
  const content = useContent("pages/footer", footerContent, { setActive: false });

  return (
    <footer className="border-t border-warm-stone/15 bg-antique-linen px-6 py-20 lg:px-12 lg:py-24">
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-col items-center gap-8 text-center lg:flex-row lg:justify-between lg:items-start lg:text-left">
          {/* Brand */}
          <div className="flex flex-col items-center lg:items-start">
            <Link to="/" className="font-script text-4xl text-soft-charcoal">
              {content.brandName}
            </Link>
            <p className="mt-3 max-w-md font-body text-sm leading-relaxed text-warm-stone">
              {content.tagline}
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-col items-center gap-4 lg:items-end">
            <div className="flex flex-wrap justify-center gap-6 text-xs tracking-widest uppercase text-warm-stone">
              <a
                href={content.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="transition-colors hover:text-faded-terracotta"
              >
                Instagram
              </a>
              <Link to="/contact" className="transition-colors hover:text-faded-terracotta">
                Contact
              </Link>
              <Link to="/privacy-policy" className="transition-colors hover:text-faded-terracotta">
                Privacy
              </Link>
            </div>

            {/* Script accent tagline */}
            <ScriptText className="text-xl">{content.scriptAccent}</ScriptText>

            {/* Copyright */}
            <p className="text-xs text-warm-stone/60">
              &copy; {new Date().getFullYear()} {content.copyright}. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
